'use client'

import * as DialogRadix from '@radix-ui/react-dialog'
import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
import type { ReactNode } from 'react'

import S from './TasksFeedNav.module.scss'

type FeedSheetProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  children: ReactNode
  footer?: ReactNode
}

/** The phone's bottom sheet for the feed's filters and order. */
export function FeedSheet({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer
}: FeedSheetProps) {
  return (
    <DialogRadix.Root open={open} onOpenChange={onOpenChange}>
      <DialogRadix.Portal>
        <DialogRadix.Overlay className={S.sheetOverlay} />
        <DialogRadix.Content className={S.sheet}>
          <span className={S.sheetHandle} aria-hidden />
          <DialogRadix.Title className={S.sheetTitle}>
            {title}
          </DialogRadix.Title>
          <VisuallyHidden.Root>
            <DialogRadix.Description>{description}</DialogRadix.Description>
          </VisuallyHidden.Root>
          <div className={S.sheetBody}>{children}</div>
          {footer ? <div className={S.sheetFooter}>{footer}</div> : null}
        </DialogRadix.Content>
      </DialogRadix.Portal>
    </DialogRadix.Root>
  )
}
